export default __webpack_public_path__ + "9a28fae788c87c01f7aa52cec26611b7.svg";